import React,{Component} from "react";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import Dictaphone from "./Dictaphone.jsx";
// reactstrap components
import {
  Col,
  Progress,
  Button
} from "reactstrap";
import NoMicrophone from "views/NoMicrophone.jsx";
import MicRecorder from 'mic-recorder-to-mp3';
import "components/custom.css";
import Sound from 'react-sound';
import {base,s3base} from "api.js";
import Speech from 'speak-tts';
// import getBlobDuration from 'get-blob-duration';
import { getBlobURL, getFile, getDuration } from "util/blobUtils.js";
let Mp3Recorder = new MicRecorder({ bitRate: 128 });

const SECONDCOUNT = 35;
const RECORDID = 1;

class ReadAloud extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRecording: false,
      blobURL: '',
      isBlocked: false,
      question: "",
      duration: 0,
      secondCount: SECONDCOUNT,
      recordCount: 0,
      recordId: RECORDID,
      intervalId: 0,
      questionId: "",
      reset: false,
      restart: false,
      correctFlag: true,
      soundStatus: false,
      file: '',
      trans: '',
      eval_strategy: this.props.strategy === 1 || this.props.strategy === 2 ? this.props.strategy : 1,
      selected_sentence: '',
      show_buttons: false,
      one_liner_ready: false,
      isStopping: false,  
    isProcessing: false,
    isSkip:true
    };
    // eval_strategy = 1(normal), 2(oneLiner)
  }

  componentDidMount() {
    console.log("we are in the ReadAloud of Question")
    if (!this.props.answer) {
      var intervalId = setInterval(this.timer, 1000);
      this.setState({ intervalId: intervalId });
    }

    navigator.getUserMedia({ audio: true },
      () => {
        this.setState({ isBlocked: false });
      }, () => {
        this.setState({ isBlocked: true })
      },
    );

    // Detect Selection for OneLiner.
    // document.addEventListener('pointerup', this.pointerUp);
  }

  pointerUp = () => {
    const selected = document.getSelection().toString();
    if (selected.length > 0) {
      this.setState({
        selected_sentence: selected,
        show_buttons: true
      });
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data) {
      if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
        clearInterval(state.intervalId);
        clearInterval(state.recordId);
        //var intervalId = setInterval(ReadAloud.timer1, 1000);
         if (state.isRecording) {
                 SpeechRecognition.stopListening();
                 try {
                   Mp3Recorder.stop();
                 } catch (e) {
                   console.log('Error stopping recorder:', e);
                 }
               }

               if (state.blobURL) {
          URL.revokeObjectURL(state.blobURL);
        }
        return {
          correctFlag: true,
          recordCount: 0,
          isRecording: false,
          secondCount: SECONDCOUNT,
          questionId: props.data.id,
          blobURL: '',
          trans: '',
          reset: true,
          start_record: true,
          recordId: 0,  
        isStopping: false,  
        isProcessing: false,
        };
      }else{
        if (!state.questionId) {
          return {correctFlag:true,questionId: props.data.id};
        }
      }

      }
  }

  revokeBlobURL = () => {
    const { blobURL } = this.state;
    if (blobURL) {
      try {
        // Only revoke if URL exists and is a proper blob URL
        if (blobURL.startsWith("blob:")) {
        URL.revokeObjectURL(blobURL);
          console.log("🧹 Revoked blob URL instantly:", blobURL);
        }
      } catch (err) {
        console.error("⚠️ Failed to revoke blob URL:", err);
      } finally {
        // Clear from state to prevent reuse
          this.setState({ blobURL: '' });
      }
    }
  };

  start = () => {
    this.setState({ soundStatus:true});
  };

  handleSongFinishedPlaying = () =>{
    if (this.state.isBlocked) {
      console.log('Permission Denied');
    } else {
      SpeechRecognition.startListening({ continuous: true, language: 'en-GB' });
      Mp3Recorder = new MicRecorder({ bitRate: 128 });
      Mp3Recorder
        .start()
        .then(() => {
          this.setState({ isRecording: true,blobURL:'',soundStatus:false ,isStopping: false,
        isProcessing: false});
          if (this.props.soundChecked) {
            console.log("ReadAloud check", this.props.soundChecked);
            console.log(this.props?.soundChecked);
            this.props.soundChecked();
          }
        }).catch((e) => {
          console.error(e)
        SpeechRecognition.stopListening();
      this.setState({
        soundStatus: false,
        isStopping: false,
        isProcessing: false
      });});
    }
  }

  stopTest = async () => {
    if (this.state.isProcessing) return;

    if (!this.state.isBlocked && this.state.isRecording) {
      this.setState({ isProcessing: true });
      Mp3Recorder
        .stop()
        .getMp3()
        .then(async ([buffer, blob]) => {
          this.revokeBlobURL();

          if(blob && blob.size > 0) {
            // const blobURL = URL.createObjectURL(blob);
            // let duration = await getBlobDuration(blobURL);
            // const duration = await this.getDuration(blobURL);
            // let file = new File([blob], 'noname.mp3', { type: blob.type });
            const duration = await getDuration(blob);
            const file = await getFile(blob, buffer,'noname.mp3');
            const blobURL = await getBlobURL(blob, file);
  
            SpeechRecognition.stopListening();
            this.setState({
              blobURL,
              file:file,
              duration:duration,
              isRecording:false,
              recordCount:100,
              isProcessing: false,
            })
            
            // const dataToSend = {
            //   data: file,
            //   audio_text: this.state.trans,
            //   duration: duration
            // };
            // this.props.nextQuestion(dataToSend);

          }else{
            // const dataToSend = {
            //   data: null,
            //   audio_text: this.state.trans,
            //   duration: 0
            // };
            // this.props.nextQuestion(dataToSend);
              this.setState({
              file:null,
              duration:0,
              isRecording:false,
              recordCount:100,
              saveTranscript: true,
              isProcessing: false,
            })
          }
        }).catch((e) => {
          console.log(e)
          this.setState({ isProcessing: false, isRecording: false });
        });
    } else {
      console.log("Read Aloud : inside stopTest else");
      if(!this.state.isProcessing){
        this.setState({ isProcessing: true });
        this.props.nextQuestion({
          data: this.state.file,
          audio_text: this.state.trans,
          duration: this.state.duration
        });
        this.setState({ isProcessing: false });
      }
    }
  }

  stop = () => {
   if (this.state.isStopping || this.state.isProcessing || !this.state.isRecording) {
    console.log('Stop already in progress or not recording');
    return;
  }

  // Immediately set stopping flag to prevent duplicate calls
  this.setState({ isStopping: true, isProcessing: true });
    if (!this.state.isBlocked && this.state.isRecording) {
        SpeechRecognition.stopListening();
      Mp3Recorder
        .stop()
        .getMp3()
        .then(async ([buffer, blob]) => {
          this.revokeBlobURL();
          
          if(blob && blob.size > 0) {
            // const blobURL = URL.createObjectURL(blob);
            // let file = new File([blob], 'noname.mp3', { type: blob.type });
            // let duration = await getBlobDuration(blobURL);
            // let duration = 0;
            // try {
            //   duration = await this.getDuration(blobURL);
            // } catch (err) {
            //   duration = 0;
            //   console.error("❌ Error calculating duration:", err);
            // }
            const duration = await getDuration(blob);
            const file = await getFile(blob, buffer,'noname.mp3');
            const blobURL = await getBlobURL(blob, file);
            this.setState({
              blobURL,
              isRecording: false,
              recordCount: 100,
              file: file,
              duration: duration,
              isStopping: false,
              isProcessing: false
            });
            
            SpeechRecognition.stopListening();
            // const dataToSend = {
            //   data: file,
            //   audio_text: this.state.trans,
            //   duration: duration,
            //   strategy: this.state.eval_strategy
            // };
            // this.props.submit(dataToSend, true);
            // this.props.showResult();
          }else{
            this.setState({
              blobURL: '',
              isRecording: false,
              recordCount: 100,
              file: null,
              duration: 0,
              isStopping: false,
              isProcessing: false
            });
            
            SpeechRecognition.stopListening();
            // const dataToSend = {
            //   data: null,
            //   audio_text: this.state.trans,
            //   duration: 0,
            //   strategy: this.state.eval_strategy
            // };
            // this.props.submit(dataToSend, true);
          }
          SpeechRecognition.stopListening();
        }).catch((e) => console.log(e)
        );
    }else{
       this.props.nextQuestion({
        data: this.state.file,
        audio_text: this.state.trans,
        duration: this.state.duration
      });
    }
  };

  updateCorrect = () => {
     // this.props.submit({'data':'',duration:this.state.duration});
     this.setState({correctFlag:false})
  }

  skip = () => {
     this.setState({isSkip:false})
    clearInterval(this.state.intervalId);
    this.start();
    var recordId = setInterval(this.timerRecord, 1000);
    this.setState({recordId: recordId,secondCount:0});
  };

  timer = () => {
    if (this.state.secondCount === 1) {
      clearInterval(this.state.intervalId);
      this.start();
      var recordId = setInterval(this.timerRecord, 1000);
      this.setState({recordId: recordId});
    }
    this.setState({ secondCount: this.state.secondCount -1 });
  }

  selectSpan = (e,text) => {
    if (!this.props.testMode) {
        const speech = new Speech();
        speech.speak({
        text: text,
      }).then(() => {
          console.log("Success !")
      }).catch(e => {
          console.error("An error occurred :", e)
      });
    }


  }

  timerRecord = () => {
    if (this.state.recordCount === 35) {
      clearInterval(this.state.recordId);
      this.stop();
    }
    this.setState({ recordCount: this.state.recordCount + 1 });
  }

  componentWillUnmount = () => {
    this.cleanupResources();
    document.removeEventListener('pointerup', this.pointerUp);
    
  }

  cleanupResources = () => {
    // Clear any running intervals
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
      console.log("Interval for question countdown cleared.");
    }
    if (this.state.recordId) {
      clearInterval(this.state.recordId);
      console.log("Interval for recording countdown cleared.");
    }

      // URL.revokeObjectURL(this.state.blobURL);
      this.revokeBlobURL();

    // Stop speech recognition and recording if active
    if (this.state.isRecording) {
      SpeechRecognition.stopListening();
      console.log("Stopped speech recognition.");
      if (Mp3Recorder) {
        Mp3Recorder.stop();
        console.log("Stopped MP3 recorder.");
      }
    }
    if (this.state.isRecording) {
    try {
      Mp3Recorder.stop();
    } catch (e) {
      console.log('Error stopping recorder on unmount:', e);
    }
  }
  };

  setTrans = (a)=>{
    if (this.state.trans != a) {
      this.setState({trans:a})
    }
  }

  normalStrategy = () => {
    this.setState({ eval_strategy: 1 });
    this.props.setStrategy(1);
  }

  oneLinerStrategy = () => {
    this.setState({ eval_strategy: 2 });
    this.props.setStrategy(2);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.stopRecording) {
      this.stopTest();
    }
  }

  render() {
    let question = "";
    if (this.props.restart) {
       this.setState({isSkip:true})
      this.props.restartQue();
    }

    // if (this.props.stopRecording) {
    //   this.stopTest();
    // }
    if (this.props.data) {
      question = this.props.data.question;
      if (this.state.correctFlag) {
        this.updateCorrect();
      }
    }
    if (this.state.reset) {
      var intervalId = setInterval(this.timer, 1000);
      this.setState({intervalId: intervalId,reset:false});
    }

    if (this.state.isBlocked) {
      return (<NoMicrophone />);
    }

    const { eval_strategy, show_buttons, one_liner_ready, selected_sentence } = this.state;
    const filtered_question = question.replace(/<span[^>]*>?/g, ' __').replace(/<[^>]*span>?/g, '__');
    
    return (
      <>
        <Dictaphone setTrans={this.setTrans} status={this.state.reset || this.state.isRecording} />
        <Col xs={12} className={eval_strategy === 1 ? '' : ''}>
          <h5><b></b></h5>
        </Col>
        <Col xs={12} className={eval_strategy === 1 ? '' : 'three-border'}>
          {eval_strategy === 2 &&
            <span className="border-label">BETA</span>
          }
          <div className="col-lg-12 text-center">
            { !this.props.resultMode &&
              <>
                {/*!this.props.testMode &&
                  <div className="scoring-mode">
                    <button className={`btn ${eval_strategy === 1 ? 'btnActive' : ''}`} onClick={this.normalStrategy}>Normal</button>
                    <button className={`btn ${eval_strategy === 2 ? 'btnActive' : ''}`} onClick={this.oneLinerStrategy}>One Line Strategy</button>
                  </div>
                */}
                <div className="scoring-mode">
                  <button className={`btn ${eval_strategy === 1 ? 'btnActive' : ''}`} onClick={this.normalStrategy}>Normal</button>
                  <button className={`btn ${eval_strategy === 2 ? 'btnActive' : ''}`} onClick={this.oneLinerStrategy}>One Line Strategy</button>
                </div>

                <div className="audio-box">
                  <h4>Recorded Answer</h4>
                  <p><strong>Current status:</strong></p>
                  {/* <p>{ this.state.blobURL === ' '&& this.state.isRecording?"Recording started": 'Recording starts in '+this.state.secondCount+ ' seconds' } </p> */}
                  <p>
  {this.state.isRecording 
    ? "Recording started" 
    : this.state.blobURL 
      ? "Recording Finished" 
      : `Recording starts in ${this.state.secondCount} seconds`
  }
</p>

                  {!this.props.testMode && this.state.blobURL === '' && !this.state.isRecording && this.state.isSkip && <div className='stop-btn'><Button color="success" onClick={this.skip} size="sm">Skip</Button></div> }
                  <hr></hr>
                  {/*this.state.isRecording && "Recording Time : "+this.state.recordCount*/}
                  {!this.props.testMode && this.state.isRecording && this.state.recordCount !== 0 && <div className='stop-btn'><Button color="success" onClick={this.stop} size="sm">Stop</Button></div>}
                  <hr></hr>
                  <Progress color="info" value={(this.state.recordCount*3)} />
                  <div className="audo-line"><span className="progress-bar-fill-Read intro"></span></div>
                </div>
              </>
            }
            <Col xs={12}>
              {this.state.blobURL && !this.props.testMode && 
                <audio src={this.state.blobURL} controls="controls" onError={(e) => {
        console.error('Audio playback error:', e);
        // Don't revoke the URL on error, user might want to retry
      }} />
              }
            </Col>
          </div>
        </Col>

        <Col xs={12} className={eval_strategy === 1 ? '' : 'border-three'}>
          <h5>
            {filtered_question.split(' ').map(function(item, index){
              return <React.Fragment key={index}><span className={(this.props.testMode) ? "" : "speach-text"} onClick={(e) => this.selectSpan(e,item)} >{item}</span>&nbsp; </React.Fragment>;
            },this)}
          </h5>
        </Col>

        {!this.props.resultMode && this.state.soundStatus &&
          <Sound
            url={s3base + "/ptedata/ptemedia/beep.mp3"}
            playStatus={Sound.status.PLAYING}
            onFinishedPlaying={this.handleSongFinishedPlaying}
             onError={(errorCode, description) => {
                      
                      console.error(
                        "Sound playback error:",
                        errorCode,
                        description
                      );
                
                    }}
          />
        }
      </>
    );
  }
}

export default ReadAloud;
